import React, { useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { api, apiError } from "../lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const { token } = useParams();
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("Password must be at least 6 characters"); return; }
    if (password !== confirm) { toast.error("Passwords don't match"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      toast.success("Password updated");
      setTimeout(() => nav("/login"), 1500);
    } catch (err) {
      toast.error(apiError(err, "Reset failed"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20">
      <div className="font-mono-cal text-[11px] uppercase tracking-[0.2em] text-[#666] mb-4">[04] Set new password</div>
      <h1 className="font-display font-bold text-5xl mb-8">Reset password</h1>
      {done ? (
        <div className="cal-card p-8" data-testid="reset-done">
          <div className="font-mono-cal text-[10px] uppercase tracking-widest text-[#00A36C] mb-2">[ SUCCESS ]</div>
          <h2 className="font-display font-bold text-2xl mb-2">Password updated</h2>
          <p className="text-[#666] mb-4">Redirecting to sign-in…</p>
        </div>
      ) : (
        <form onSubmit={submit} className="cal-card p-8 space-y-5" data-testid="reset-form">
          <div>
            <label className="cal-label">New password (min 6)</label>
            <input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className="cal-input" data-testid="reset-password" />
          </div>
          <div>
            <label className="cal-label">Confirm password</label>
            <input type="password" required minLength={6} value={confirm} onChange={(e) => setConfirm(e.target.value)} className="cal-input" data-testid="reset-confirm" />
          </div>
          <button disabled={loading} className="cal-btn w-full" data-testid="reset-submit">
            {loading ? "Updating…" : "Set new password →"}
          </button>
        </form>
      )}
      <p className="mt-6 text-sm text-[#666]">
        <Link to="/login" className="underline hover:text-[#FF4F00]" data-testid="back-login">← Back to sign in</Link>
      </p>
    </div>
  );
}
